export default __webpack_public_path__ + "static/media/HelveticaNeueBd.497b4484.ttf";